import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { LetterrequestcustomerIgnoreService } from 'src/app/Service/Letter/LetterrequestcustomerIgnore.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LetterrequestcustomerIgnore',
  templateUrl: './LetterrequestcustomerIgnore.component.html',
  styleUrls: ['./LetterrequestcustomerIgnore.component.scss']
})
export class LetterrequestcustomerIgnoreComponent implements OnInit {
  Filter_title: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private LetterrequestcustomerIgnore_Service: LetterrequestcustomerIgnoreService,
    private Alertify_Service: AlertifyService,
    private Customer_Service: CustomerService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
  ) { }


  DataList_LetterrequestcustomerIgnore: Array<General_Interface> = []


  ngOnInit() {
    this.Nav_Service.CheckValidPage(2227).subscribe(
      data => {
        this.ReadData_LetterrequestcustomerIgnore()
      }
      
    )



  }

  ReadData_LetterrequestcustomerIgnore() {
    this.Procssing = true
    this.LetterrequestcustomerIgnore_Service.GetCustomer().subscribe(
      data => {
        this.DataList_LetterrequestcustomerIgnore = data
        this.Procssing = false
      }
    )
  }


  Set_Selected_Customer_Record(item: Customer_List_Interface) {

    this.modalRef_Customer.hide()
    this.Procssing = true
    this.LetterrequestcustomerIgnore_Service.Add(item.id).subscribe(
      data => {
        this.Procssing = false
        if (data['id'] == -1) {
          this.Alertify_Service.ErrorMessage("مشتری انتخاب شده است")
        }
        else {
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.ReadData_LetterrequestcustomerIgnore()
        }
      }
    )
  }

  DeleteData(item: General_Interface) {
    this.Procssing = true
    this.LetterrequestcustomerIgnore_Service.Delete(item.id).subscribe(
      data => {
        this.Procssing = false
        this.Alertify_Service.SuccessMessage("اطلاعات حذف شد")
        this.ReadData_LetterrequestcustomerIgnore()
      }
    )
  }




  //#region Customer

  modalRef_Customer: any;
  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Customer = this.modalService.show(template);
  }


  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  Search_CodeName_Customer_Table: string = ''
  DataList_Customer: Array<Customer_List_Interface> = []
  ProcssingCustomer: boolean = false
  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {


      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

}
